import React, { useState } from 'react';
import { Menu, X, MapPin, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white/98 backdrop-blur-md shadow-xl border-b-2 border-emerald-100 fixed w-full top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_c23aa9a6-13e0-48f7-b58f-0e02920451ab/artifacts/n1qvajmj_LOGO%20LES%20PLATANES.png"
                alt="Logo Les Platanes"
                className="h-12 w-auto object-contain"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800">Les Platanes</h1>
              <p className="text-sm text-emerald-700 font-medium">À 200m des thermes</p>
            </div>
          </div>

          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('accueil')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Accueil
            </button>
            <button 
              onClick={() => scrollToSection('emplacement')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Emplacement
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('appartements')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Appartements
            </button>
            <button 
              onClick={() => scrollToSection('activites')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Activités
            </button>
            <button 
              onClick={() => scrollToSection('garden')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Notre jardin
            </button>
            <button 
              onClick={() => scrollToSection('infos-pratiques')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Infos pratiques
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-emerald-700 transition-all duration-300 font-medium border-b-2 border-transparent hover:border-emerald-600"
            >
              Contact
            </button>
          </nav>

          <div className="flex items-center space-x-4">
            <div className="hidden lg:flex items-center space-x-4 text-sm text-gray-600">
              <div className="flex items-center space-x-1">
                <Phone className="h-4 w-4" />
                <span>+33 6 67 59 25 19</span>
              </div>
              <div className="flex items-center space-x-1">
                <Mail className="h-4 w-4" />
                <span>Rigaud.lesplatanes@gmail.com</span>
              </div>
            </div>
            
            <button
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-2">
              <button 
                onClick={() => scrollToSection('accueil')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Accueil
              </button>
              <button 
                onClick={() => scrollToSection('emplacement')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Emplacement
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('appartements')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Appartements
              </button>
              <button 
                onClick={() => scrollToSection('activites')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Activités
              </button>
              <button 
                onClick={() => scrollToSection('garden')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Notre jardin
              </button>
              <button 
                onClick={() => scrollToSection('infos-pratiques')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Infos pratiques
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-left text-gray-700 hover:text-green-600 transition-colors py-2"
              >
                Contact
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;